// import '@capacitor-community/http';
import { IonAlert, IonContent, IonFooter, IonIcon, IonItem, IonLabel, IonListHeader, IonNote, IonPage, useIonViewDidEnter } from '@ionic/react';
import { albumsOutline, cardOutline, closeOutline, exitOutline, helpOutline, informationCircleOutline, informationOutline, lockClosedOutline, personOutline, statsChartOutline } from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { deslogar, requestService, usuarioExcluir } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import ClientePageHeader from '../../../../../components/ClientePageHeader';
import './Conta.css';

const Conta: React.FC = () => {

    const history = useHistory();
    const [showToast2, setShowToast2] = useState(false);
    const [showToast3, setShowToast3] = useState(false);
    const { notificacoes, setNotificacoes } = useContext(MessageContext);
    const [showNotificacoes, setShowNotificacoes] = useState(false);
    const { esconderMenu, setEsconderMenu } = useContext(MessageContext);

    useIonViewDidEnter(() => {
        setEsconderMenu(false);
    });

    return (
        <IonPage>

            <ClientePageHeader title="Conta" />
            <IonContent className="conta-page">
                <div className="conta-page-content">
                    <IonListHeader>Geral</IonListHeader>
                    <IonItem lines="full" button routerLink="/cliente/contaalt" routerDirection="forward" onClick={() => { }} detail>
                        <IonIcon color='medium' slot="start" icon={personOutline} />
                        <IonLabel>Meus dados</IonLabel>
                    </IonItem>
                    <IonItem lines="full" button onClick={() => { }} detail hidden={true}>
                        <IonIcon color='medium' slot="start" icon={statsChartOutline} />
                        <IonLabel>Relatórios</IonLabel>
                    </IonItem>
                    <IonListHeader hidden={true}>Assinatura</IonListHeader>
                    <IonItem lines="full" button onClick={() => { }} detail hidden={true}>
                        <IonIcon color='medium' slot="start" icon={cardOutline} />
                        <IonLabel>Forma de pagamento</IonLabel>
                    </IonItem>
                    <IonItem lines="full" button onClick={() => { }} detail hidden={true}>
                        <IonIcon color='medium' slot="start" icon={albumsOutline} />
                        <IonLabel>Histórico de pagamentos</IonLabel>
                    </IonItem>
                    <IonListHeader>Informações</IonListHeader>
                    <IonItem lines="full" button onClick={() => { }} detail hidden={true}>
                        <IonIcon color='medium' slot="start" icon={helpOutline} />
                        <IonLabel>Ajuda</IonLabel>
                    </IonItem>
                    <IonItem lines="full" button routerLink="/cliente/sobre" routerDirection="forward" onClick={() => { }} detail hidden={true}>
                        <IonIcon color='medium' slot="start" icon={informationOutline} />
                        <IonLabel>Sobre</IonLabel>
                    </IonItem>
                    <IonItem lines="full" button routerLink="/cliente/termospolitica" routerDirection="forward" onClick={() => { }} detail>
                        <IonIcon color='medium' slot="start" icon={lockClosedOutline} />
                        <IonLabel>Privacidade e termos de uso</IonLabel>
                    </IonItem>
                    <IonItem lines="full" button onClick={() => { setShowToast3(true); }} >
                        <IonIcon color='medium' slot="start" icon={closeOutline} />
                        <IonLabel>Excluir conta e sair</IonLabel>
                        <IonAlert
                            isOpen={showToast3}
                            onDidDismiss={() => setShowToast3(false)}
                            cssClass='my-custom-class'
                            header={'Excluir conta'}
                            message={'Deseja realmente <strong>excluir</strong> sua conta e sair?'}
                            buttons={[
                                {
                                    text: 'Cancelar',
                                    role: 'cancel',
                                },
                                {
                                    text: 'Excluir',
                                    cssClass: 'primary',
                                    handler: () => {
                                        let telefone = window.localStorage.getItem("telefone") + '';
                                        requestService(usuarioExcluir.url.replace("{id}", telefone), {
                                            method: usuarioExcluir.method,
                                            headers: [
                                                ["token", localStorage.getItem("token") || ""],
                                                ["perfil", window.localStorage.getItem("perfil") || ""],
                                                ["marca", window.localStorage.getItem("marca") || ""],
                                            ],
                                            credentials: 'include'
                                        },
                                            history,
                                            (response: any) => {
                                                //localStorage.clear();
                                                // window.localStorage.setItem("cpf", "");
                                                window.localStorage.setItem("telefone", "");
                                                window.localStorage.setItem("nome", "");
                                                window.localStorage.setItem("token", "");
                                                window.localStorage.removeItem("perfil");
                                                window.localStorage.removeItem("watch");
                                                window.localStorage.removeItem("logado");
                                                window.localStorage.removeItem("enderecoEntrega");
                                                window.localStorage.removeItem("latitudeEntrega");
                                                window.localStorage.removeItem("longitudeEntrega");
                                                window.localStorage.removeItem("taxaEntrega");
                                                window.localStorage.removeItem("complementoEntrega");
                                                window.localStorage.removeItem("tipoAgendamento");
                                                window.localStorage.removeItem("dataAgendamento");
                                                window.localStorage.removeItem("horaAgendamento");
                                                window.location.reload();
                                            },
                                            (error: any) => {
                                                //localStorage.clear();
                                                console.log("erro", error);
                                                // window.localStorage.setItem("cpf", "");
                                                window.localStorage.setItem("telefone", "");
                                                window.localStorage.setItem("nome", "");
                                                window.localStorage.setItem("token", "");
                                                window.localStorage.removeItem("perfil");
                                                window.localStorage.removeItem("watch");
                                                window.localStorage.removeItem("logado");
                                                window.localStorage.removeItem("enderecoEntrega");
                                                window.localStorage.removeItem("latitudeEntrega");
                                                window.localStorage.removeItem("longitudeEntrega");
                                                window.localStorage.removeItem("taxaEntrega");
                                                window.localStorage.removeItem("complementoEntrega");
                                                window.localStorage.removeItem("tipoAgendamento");
                                                window.localStorage.removeItem("dataAgendamento");
                                                window.localStorage.removeItem("horaAgendamento");
                                                window.location.reload();
                                            });
                                    }
                                }
                            ]}
                        />
                    </IonItem>
                    <IonItem lines="full" button onClick={() => { setShowToast2(true); }} >
                        <IonIcon color='medium' slot="start" icon={exitOutline} />
                        <IonLabel>Sair</IonLabel>
                        <IonAlert
                            isOpen={showToast2}
                            onDidDismiss={() => setShowToast2(false)}
                            cssClass='my-custom-class'
                            header={'Sair'}
                            message={'Deseja realmente <strong>desconectar</strong> de sua conta?'}
                            buttons={[
                                {
                                    text: 'Cancelar',
                                    role: 'cancel',
                                },
                                {
                                    text: 'Sair',
                                    cssClass: 'primary',
                                    handler: () => {

                                        requestService(deslogar.url, {
                                            method: deslogar.method,
                                            headers: [
                                                ["token", localStorage.getItem("token") || ""],
                                                ["perfil", window.localStorage.getItem("perfil") || ""],
                                                ["marca", window.localStorage.getItem("marca") || ""],
                                            ],
                                            credentials: 'include'
                                        },
                                            history,
                                            (response: any) => {
                                                //localStorage.clear();
                                                // window.localStorage.setItem("cpf", "");
                                                window.localStorage.setItem("telefone", "");
                                                window.localStorage.setItem("nome", "");
                                                window.localStorage.setItem("token", "");
                                                window.localStorage.removeItem("perfil");
                                                window.localStorage.removeItem("watch");
                                                window.localStorage.removeItem("logado");
                                                window.localStorage.removeItem("enderecoEntrega");
                                                window.localStorage.removeItem("latitudeEntrega");
                                                window.localStorage.removeItem("longitudeEntrega");
                                                window.localStorage.removeItem("taxaEntrega");
                                                window.localStorage.removeItem("complementoEntrega");
                                                window.localStorage.removeItem("tipoAgendamento");
                                                window.localStorage.removeItem("dataAgendamento");
                                                window.localStorage.removeItem("horaAgendamento");
                                                window.location.reload();
                                            },
                                            (error: any) => {
                                                //localStorage.clear();
                                                console.log("erro", error);
                                                // window.localStorage.setItem("cpf", "");
                                                window.localStorage.setItem("telefone", "");
                                                window.localStorage.setItem("nome", "");
                                                window.localStorage.setItem("token", "");
                                                window.localStorage.removeItem("perfil");
                                                window.localStorage.removeItem("watch");
                                                window.localStorage.removeItem("logado");
                                                window.localStorage.removeItem("enderecoEntrega");
                                                window.localStorage.removeItem("latitudeEntrega");
                                                window.localStorage.removeItem("longitudeEntrega");
                                                window.localStorage.removeItem("taxaEntrega");
                                                window.localStorage.removeItem("complementoEntrega");
                                                window.localStorage.removeItem("tipoAgendamento");
                                                window.localStorage.removeItem("dataAgendamento");
                                                window.localStorage.removeItem("horaAgendamento");
                                                window.location.reload();
                                            });
                                    }
                                }
                            ]}
                        />
                    </IonItem>
                </div>
            </IonContent>
            <IonFooter className="ion-no-border">
                <IonItem lines="none">
                    <IonIcon color='medium' slot="start" icon={informationCircleOutline} />
                    <IonLabel>Versão</IonLabel>
                    <IonNote slot="end" className="footeritemnote">{window.localStorage.getItem("versao")}</IonNote>
                </IonItem>
            </IonFooter>
        </IonPage>
    );
};

export default Conta;
